import React from 'react';
import { SearchDialog } from "../SearchDialog";
import { SelectAllButton } from "../../CommonComponents/SelectAllButton";
export var Menu = function Menu(_ref) {
  var menuPlacement = _ref.menuPlacement,
      theme = _ref.theme,
      selectProps = _ref.selectProps,
      innerProps = _ref.innerProps,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(SearchDialog, {
    label: selectProps.label,
    selectPromptMessage: selectProps.selectPromptMessage,
    setMenuIsOpen: selectProps.setMenuIsOpen
  }, selectProps.isMulti && selectProps.allowSelectAll && /*#__PURE__*/React.createElement(SelectAllButton, selectProps), children);
};